module.exports = "/images/AM.png?a6330efb998d7981fa4bf038a659a059";